/* Thème neutre v3 : avis clients natifs.
   - Tri (récents, avec photos, meilleures, plus basses), filtre par note (histogramme), « Voir plus ».
   - Visionneuse de photos : clic, flèches gauche/droite, Échap, balayage tactile, piège du focus.
   Sans JavaScript la liste reste complète et lisible ; ce script ne fait qu'améliorer. */
(function () {
  'use strict';

  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function init(root) {
    if (root.__ntAvis) return;
    root.__ntAvis = true;

    var list = root.querySelector('[data-nt-list]');
    var items = list ? qsa(list, '.nt-avis__item') : [];
    var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 6;
    var shown = perPage;
    var sort = 'recent';
    var rating = 0;
    var toolbar = root.querySelector('[data-nt-toolbar]');
    var sortEl = root.querySelector('[data-nt-sort]');
    var moreBtn = root.querySelector('[data-nt-more]');
    var clearBtn = root.querySelector('[data-nt-clear]');
    var status = root.querySelector('[data-nt-status]');
    var bars = qsa(root, '[data-nt-filter]');

    items.forEach(function (li, i) { li.__i = i; });

    function cmp(a, b) {
      var ra = +a.getAttribute('data-rating'), rb = +b.getAttribute('data-rating');
      var da = a.getAttribute('data-date') || '', db = b.getAttribute('data-date') || '';
      var pa = +a.getAttribute('data-photos') > 0 ? 1 : 0, pb = +b.getAttribute('data-photos') > 0 ? 1 : 0;
      var byDate = db < da ? -1 : db > da ? 1 : 0;
      var r = 0;
      if (sort === 'best') r = rb - ra || byDate;
      else if (sort === 'worst') r = ra - rb || byDate;
      else if (sort === 'photos') r = pb - pa || byDate;
      else r = byDate;
      return r || a.__i - b.__i;
    }

    function render() {
      var visible = items.filter(function (li) {
        return !rating || +li.getAttribute('data-rating') === rating;
      });
      visible.sort(cmp);
      items.forEach(function (li) { li.hidden = true; });
      visible.forEach(function (li, i) {
        list.appendChild(li);
        li.hidden = i >= shown;
      });
      var n = Math.min(shown, visible.length);
      if (moreBtn) {
        moreBtn.hidden = visible.length <= shown;
        moreBtn.textContent = 'Voir plus d’avis (' + (visible.length - n) + ')';
      }
      if (clearBtn) clearBtn.hidden = !rating;
      if (status) {
        status.textContent = n + ' avis affiché' + (n > 1 ? 's' : '') + ' sur ' + visible.length +
          (rating ? ' (note : ' + rating + ' sur 5)' : '') +
          (sort === 'recent' ? ', du plus récent au plus ancien' : '');
      }
      bars.forEach(function (b) { b.setAttribute('aria-pressed', String(+b.getAttribute('data-nt-filter') === rating)); });
    }

    if (list && items.length) {
      if (toolbar) toolbar.hidden = false;
      render();
    }
    if (sortEl) sortEl.addEventListener('change', function () { sort = sortEl.value; shown = perPage; render(); });
    if (moreBtn) moreBtn.addEventListener('click', function () { shown += perPage; render(); });
    if (clearBtn) clearBtn.addEventListener('click', function () { rating = 0; shown = perPage; render(); });
    bars.forEach(function (b) {
      b.addEventListener('click', function () {
        var n = +b.getAttribute('data-nt-filter');
        rating = rating === n ? 0 : n;
        shown = perPage;
        render();
        if (list && rating) list.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });

    /* ---------- visionneuse ---------- */
    var tiles = qsa(root, '[data-nt-tile]');
    if (!tiles.length) return;
    var lb = null, img, cap, count, btnPrev, btnNext, btnClose, current = 0, opener = null, touchX = null;

    function build() {
      lb = document.createElement('div');
      lb.className = 'nt-avis-lb';
      lb.hidden = true;
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', 'Photos de nos clients');
      lb.innerHTML =
        '<span class="nt-avis-lb__count" aria-live="polite"></span>' +
        '<button type="button" class="nt-avis-lb__btn nt-avis-lb__close" aria-label="Fermer la visionneuse">✕</button>' +
        '<button type="button" class="nt-avis-lb__btn nt-avis-lb__prev" aria-label="Photo précédente">‹</button>' +
        '<button type="button" class="nt-avis-lb__btn nt-avis-lb__next" aria-label="Photo suivante">›</button>' +
        '<figure class="nt-avis-lb__fig"><img class="nt-avis-lb__img" alt=""><figcaption class="nt-avis-lb__cap"></figcaption></figure>';
      document.body.appendChild(lb);
      img = lb.querySelector('img');
      cap = lb.querySelector('figcaption');
      count = lb.querySelector('.nt-avis-lb__count');
      btnPrev = lb.querySelector('.nt-avis-lb__prev');
      btnNext = lb.querySelector('.nt-avis-lb__next');
      btnClose = lb.querySelector('.nt-avis-lb__close');
      btnClose.addEventListener('click', close);
      btnPrev.addEventListener('click', function () { go(-1); });
      btnNext.addEventListener('click', function () { go(1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
      lb.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        if (touchX === null) return;
        var dx = e.changedTouches[0].clientX - touchX;
        touchX = null;
        if (Math.abs(dx) > 50) go(dx < 0 ? 1 : -1);
      });
    }

    function show(i) {
      var n = tiles.length;
      current = (i + n) % n;
      var t = tiles[current];
      img.src = t.getAttribute('data-full');
      img.alt = (t.querySelector('img') || {}).alt || '';
      cap.textContent = t.getAttribute('data-caption') || '';
      count.textContent = (current + 1) + ' / ' + n;
      btnPrev.hidden = btnNext.hidden = n < 2;
      [(current + 1) % n, (current - 1 + n) % n].forEach(function (k) { new Image().src = tiles[k].getAttribute('data-full'); });
    }

    function go(d) { show(current + d); }

    function onKey(e) {
      if (!lb || lb.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      else if (e.key === 'Tab') {
        var f = qsa(lb, 'button').filter(function (b) { return !b.hidden; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        else if (f.indexOf(document.activeElement) < 0) { e.preventDefault(); first.focus(); }
      }
    }

    function open(i, from) {
      if (!lb) { build(); document.addEventListener('keydown', onKey); }
      opener = from || null;
      show(i);
      lb.hidden = false;
      document.body.classList.add('nt-avis-lock');
      btnClose.focus();
    }

    function close() {
      if (!lb) return;
      lb.hidden = true;
      img.removeAttribute('src');
      document.body.classList.remove('nt-avis-lock');
      if (opener && document.contains(opener) && !opener.hidden) opener.focus();
    }

    tiles.forEach(function (t, i) { t.addEventListener('click', function () { open(i, t); }); });
    qsa(root, '[data-nt-thumb]').forEach(function (th) {
      th.addEventListener('click', function () {
        var id = th.getAttribute('data-nt-thumb');
        for (var i = 0; i < tiles.length; i++) {
          if (tiles[i].getAttribute('data-nt-tile') === id) { open(i, th); return; }
        }
      });
    });
  }

  function boot() { qsa(document, '[data-nt-avis]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
